import { useRef } from 'react';
import styled from '@emotion/styled';
import { Container, StickyWrapper } from './Topbar.styles';
import { Css, Responsive, useIntersectionObserver } from '../../../ui';
import GatewayNavigation from '../navigation/gateway/GatewayNavigation';

export function GatewayTopbar() {
	const ref = useRef<HTMLDivElement>(null);
	const intersect = useIntersectionObserver(ref, {
		threshold: 1,
	});
	const isSticky = intersect?.isIntersecting === false;

	return (
		<StyledContainer ref={ref}>
			{/* Fixed on top */}
			<StickyWrapper isSticky={isSticky}>
				<GatewayNavigation isSticky={isSticky} />
			</StickyWrapper>
		</StyledContainer>
	);
}

const StyledContainer = styled(Container)`
	@media (${Responsive.getMediaQueryForBreakpoint('desktop')}) {
		height: 80px;
		margin-bottom: ${Css.pxToRem(14)};
	}

	.main-navigation-column {
		@media (${Responsive.getMediaQueryForBreakpoint('desktop')}) {
			padding: ${Css.pxToRem(10)} 0 0;
		}
	}
`;
